import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './input/input.component';
import { StpMaterialModule } from '../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_LABEL_GLOBAL_OPTIONS, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material';
import { InputCurrencyComponent } from './input-currency/input-currency.component';
import { InputPercentComponent } from './input-percent/input-percent.component';
import { InputNumberComponent } from './input-number/input-number.component';
import { TextareaComponent } from './textarea/textarea.component';
import { InputEmailComponent } from './input-email/input-email.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    StpMaterialModule
  ],
  exports: [
    InputComponent,
    InputCurrencyComponent,
    InputPercentComponent,
    InputNumberComponent,
    TextareaComponent,
    InputEmailComponent
  ],
  declarations: [
    InputComponent,
    InputCurrencyComponent,
    InputPercentComponent,
    InputNumberComponent,
    TextareaComponent,
    InputEmailComponent
  ],
  providers: [
    {provide: MAT_LABEL_GLOBAL_OPTIONS, useValue: {float: 'always'}},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill'}} /* standard, fill, outline */
  ]
})
export class StpInputModule { }
